import { Pipe, PipeTransform } from "@angular/core";
import { supportedTimezones } from "../models/supported-timezone";

@Pipe({
	name: "displayTimezone",
})
export class DisplayTimezonePipe implements PipeTransform {
	transform(value: string): string {
		const displayValue = supportedTimezones.find(item => item.value === value)?.label;
		return displayValue || value;
	}
}
